import axios from 'axios';
import history from '../history';
import Cookies from 'js-cookie';
import {CONFIG} from '../config';

var pathname = window.location.pathname;
var search = window.location.search;
var token = Cookies.get('Set-Cookie');

if(pathname.includes("/register-psep") || pathname.includes("/forgot-password")){
    console.log("Password => "+pathname )
}else{
    if( token === undefined || token === null ) 
    history.push('/login')
}

const instance = axios.create({
    baseURL: CONFIG.ACCOUNT_MANAGEMENT_HOST,
    headers: {
        'Accept':  'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token
    }
});

//instance.defaults.withCredentials = false;
instance.interceptors.response.use(response => {
    return response;
}, error => {
    // console.info('Err 3', pathname)
    if(pathname.includes("/forgot-password") || pathname.includes("/verify-password")){
        history.push(pathname+search)
    }else if(pathname.includes("/register-psep")){
        history.push(pathname)
    }
    // console.log(error)
    // Cookies.remove('Set-Cookie');
    // history.push('/login')
});

export default instance;